import $ from 'jquery';
import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import Globals from '../../utils/Globals';
import ReportListView from './views/ReportListView';
import Detail from './components/detail/Detail';
import DocumentComponent from '../document/Document';

class Report extends React.Component {
    static propTypes = {
        spinner: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
        const actview = new ReportListView({ history: this.props.history });
        $('#report_component').html($(actview.el));
        actview.render();
        this.props.spinner(false);
    }

    componentWillReceiveProps() {
        Globals.nextPath = this.props.location;
    }

    render() {
        return (
            <div id="report_component_wrapper">
                <div id="report_component" />
                <Route
                    path={this.props.match.url + '/:reportSavedId'}
                    render={props => (
                        <div id="report_detail">
                            <DocumentComponent closeLink="/index.reports" {...props} >
                                <Detail {...props} />
                            </DocumentComponent>
                        </div>
                )}
                />
            </div>
        );
    }
}

export default Report;



// WEBPACK FOOTER //
// ./src/components/report/Report.js